export enum PaymentTerms {
  DUE_UPON_RECEIPT = -1,
  DUE_UPON_USAGE = -2,
}
